import type { CSSProperties, ReactNode } from 'react';
import MobileHeader from './MobileHeader.js';
import { colors } from '../theme/colors.js';
import { mobileFontSize, mobileFontWeight } from '../theme/mobile-typography.js';

export interface MobileSubPageProps {
	title: string;
	children: ReactNode;
	onBack?: () => void;
	extra?: string;
	onExtraClick?: () => void;
	extraSlot?: ReactNode;
	noHeader?: boolean;
	background?: string;
	maxWidth?: number;
	contentStyle?: CSSProperties;
}

export default function MobileSubPageScaffold({
	title,
	children,
	onBack,
	extra,
	onExtraClick,
	extraSlot,
	noHeader,
	background = colors.bg.page,
	maxWidth = 960,
	contentStyle,
}: MobileSubPageProps) {
	return (
		<div style={{ minHeight: '100vh', background }}>
			{!noHeader && (
				<MobileHeader
					title={title}
					onBack={onBack}
					extra={extra}
					onExtraClick={onExtraClick}
					extraSlot={extraSlot}
				/>
			)}
			<div
				style={{
					maxWidth,
					margin: '0 auto',
					padding: '12px 12px calc(18px + env(safe-area-inset-bottom))',
					...contentStyle,
				}}
			>
				{children}
			</div>
		</div>
	);
}

export function SubPageCard({
	children,
	style,
}: {
	children: ReactNode;
	style?: CSSProperties;
}) {
	return (
		<section
			style={{
				background: colors.bg.card,
				border: `1px solid ${colors.graphic.border}`,
				borderRadius: 8,
				overflow: 'hidden',
				...style,
			}}
		>
			{children}
		</section>
	);
}

export function SubPageSection({
	title,
	extra,
	children,
	style,
}: {
	title?: ReactNode;
	extra?: ReactNode;
	children: ReactNode;
	style?: CSSProperties;
}) {
	return (
		<section style={{ marginTop: 12, ...style }}>
			{(title || extra) && (
				<div style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '0 4px 8px' }}>
					{title && (
							<h2 style={{ flex: 1, margin: 0, fontSize: mobileFontSize.title, fontWeight: mobileFontWeight.medium, lineHeight: 1.3, color: colors.text.primary }}>
							{title}
						</h2>
					)}
					{extra}
				</div>
			)}
			{children}
		</section>
	);
}
